module.exports = __webpack_public_path__ + "static/img/swhy-bg.2b84ef3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/swhy-bg.png
// module id = rUaj
// module chunks = 3